import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { queryKeyMap } from "@/features/query-client";

import { searchLenderApplications } from "../../api";

type ResponseType = Awaited<ReturnType<typeof searchLenderApplications>>;

export const useSearchLenderApplications = (
  lenderCompanyId: number,
  search: string,
) => {
  return useQuery<ResponseType, AxiosError>({
    queryKey: queryKeyMap.searchLenderApplications(search),
    queryFn: async () => {
      if (Object.keys(search).length <= 2) {
        return {
          items: [],
          count: 0,
        };
      }

      return await searchLenderApplications(lenderCompanyId, search);
    },
  });
};
